import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";

const BulletInput = ({
  label,
  name,
  placeholder = "Add details",
  value = [""],
  onChange,
  enableAddNew = true,
}) => {
  const [items, setItems] = useState(Array.isArray(value) ? value : [""]);

  useEffect(() => {
    setItems(value);
  }, [value]);

  const handleChange = (index, newValue) => {
    const updated = [...items];
    updated[index] = newValue;
    setItems(updated);
    onChange?.({
      target: {
        name: name,
        value: updated,
      },
    });
  };

  const handleAdd = () => {
    const updated = [...items, ""];
    setItems(updated);
    onChange?.({
      target: {
        name: name,
        value: updated,
      },
    });
  };

  const handleRemove = (index) => {
    const updated = items.filter((_, i) => i !== index);
    const finalItems = updated.length ? updated : [""];
    setItems(finalItems);
    onChange?.({
      target: {
        name: name,
        value: finalItems,
      },
    });
  };

  return (
    <div className="flex flex-col gap-4">
      {/* Label */}
      {label && (
        <label className="block text-base sm:text-lg font-semibold text-text-primary mb-2 font-poppins">
          {label}
        </label>
      )}

      {/* Items */}
      <div className="space-y-3">
        {items.map((item, index) => (
          <div key={index} className="flex gap-2 items-start">
            <span className="text-primary font-bold text-lg mt-3">•</span>
            <input
              type="text"
              value={item}
              onChange={(e) => handleChange(index, e.target.value)}
              placeholder={placeholder}
              className="flex-1 px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-1 focus:ring-primary text-sm"
            />
            {items.length > 1 && (
              <button
                type="button"
                onClick={() => handleRemove(index)}
                className="p-3 text-text-muted hover:text-status-danger hover:bg-red-50 rounded-lg transition-colors mt-0"
                title="Remove item"
              >
                <Trash2 size={18} />
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Add New Button */}
      {enableAddNew && (
        <button
          type="button"
          onClick={handleAdd}
          className="flex self-end items-center text-primary hover:text-primary-navy font-medium text-sm transition-all"
        >
          + Add Item
        </button>
      )}

      {/* Preview */}
      {items.some((s) => s.trim()) && (
        <div className="mt-4 p-4 bg-background-DEFAULT rounded-lg border border-border">
          <h3 className="text-xs font-semibold text-text-primary uppercase mb-3 font-poppins">
            {name ? name : ""} Preview
          </h3>
          {items.some((d) => d.trim()) && (
            <ul className="list-disc pl-5 space-y-1 text-sm text-text-secondary">
              {items
                .filter((d) => d.trim())
                .map((desc, indx) => (
                  <li key={indx}>{desc}</li>
                ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default BulletInput;
